module.exports = __webpack_public_path__ + "media/alarm.74477816.mp3";